import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import moment from 'moment';

import API_BASE_URL from '../config';
import './HHDailyOperatorsInfo.css'; // 👈 Nuevo CSS específico
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SignatureCanvas from 'react-signature-canvas';


const ESTADOS_SERVICIO = {
  LLEGADAS: {
    NACIONAL: ["ASIGNADO", "INICIADO", "EQUIPAJE", "STDBY", "PAUSE", "CONCLUIDO", "NOSHOW"],
    INTERNACIONAL: ["ASIGNADO", "INICIADO", "MIGRACION", "EQUIPAJE", "ADUANA", "STDBY", "PAUSE", "CONCLUIDO", "NOSHOW"],
  },
  SALIDAS: {
    NACIONAL: ["ASIGNADO", "INICIADO", "STDBY", "PAUSE", "CONCLUIDO", "NOSHOW"],
    INTERNACIONAL: ["ASIGNADO", "INICIADO", "STDBY", "PAUSE", "CONCLUIDO", "NOSHOW"],
  },
};

const MisServiciosPage = () => {
  const token = useSelector((state) => state.auth.token);
  const [servicios, setServicios] = useState([]);
  const decoded = token ? jwtDecode(token) : null;
  const noColaborador = decoded?.id;
  const [modalQR, setModalQR] = useState({ abierto: false, servicio: null });
  const [mostrarModalEncuesta, setMostrarModalEncuesta] = useState(false);
  const [feedback, setFeedback] = useState('');
  const [comentarios, setComentarios] = useState('');
  const [codigoQR, setCodigoQR] = useState('');
  const [qrValidado, setQrValidado] = useState(false);
  const [erroresQR, setErroresQR] = useState([]);
  const [mostrarModalConexion, setMostrarModalConexion] = useState(false);
  const [datosConexion, setDatosConexion] = useState({ servicio: null, aerolinea: '', vuelo: '' });
  const [mostrarModalSTD, setMostrarModalSTD] = useState(false);
  const [modoModalSTD, setModoModalSTD] = useState('');
  const [servicioSTD, setServicioSTD] = useState(null);
  const [checkpointTexto, setCheckpointTexto] = useState('');


  const firmaPasajeroRef = useRef(null);
  const firmaAgenteRef = useRef(null);


  useEffect(() => {
    const fetchServicios = async () => {
      if (!noColaborador) return;

      try {
        const response = await axios.get(
          `${API_BASE_URL}api/servicios/colaborador/${noColaborador}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const serviciosConEstado = response.data.map((servicio) => ({
          ...servicio,
          expanded: false,
        }));

        setServicios(serviciosConEstado);
      } catch (error) {
        console.error('Error al obtener servicios del colaborador:', error);
      }
    };

    fetchServicios();
  }, [noColaborador, token]);

  const obtenerEstadosPorServicio = (tipoService, intNac) => {
    const tipo = tipoService?.toUpperCase();
    const nacionalidad = intNac?.toUpperCase();
    return ESTADOS_SERVICIO[tipo]?.[nacionalidad] || [];
  };

  const getIcon = (etapa) => {
    switch (etapa) {
      case 'ASIGNADO': return <i className='fa fa-user' />;
      case 'INICIADO': return <i className="fa fa-play" />;
      case 'STDBY': return <i className="fa fa-pause-circle" />;
      case 'PAUSE': return <i className="fa fa-stop-circle" />;
      case 'MIGRACION': return <i className="fa fa-passport" />;
      case 'EQUIPAJE': return <i className="fa fa-suitcase" />;
      case 'ADUANA': return <i className="fa fa-search-dollar" />;
      case 'CONCLUIDO': return <i className="fa fa-check-circle" />;
      case 'NOSHOW': return <i className="fa fa-user-slash" />;
      case 'ABORDAJE': return <i className="fa fa-plane-departure" />;
      case 'FINALIZADO': return <i className="fa fa-check" />;
      default: return etapa;
    }
  };

  const actualizarStatus = async (_id, nuevoStatus) => {
    const horaFin = moment().format('YYYY-MM-DD HH:mm:ss');

    try {
      await axios.put(`${API_BASE_URL}api/servicios/${_id}`, {
        statusServicio: nuevoStatus, horaFin
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success(`Estado actualizado a ${nuevoStatus}`);
      // 🔄 refresca lista después de cambio
      const response = await axios.get(`${API_BASE_URL}api/servicios/colaborador/${noColaborador}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setServicios(response.data);
    } catch (error) {
      console.error('Error al actualizar estado:', error);
      toast.error('No se pudo actualizar el estado.');
    }
  };

  const ejecutarAccionPorEtapa = (etapa, service) => {
    switch (etapa) {
      case 'INICIADO':
        setModalQR({ abierto: true, servicio: service });
        break;
      case 'STDBY':
        setServicioSTD(service);
        setModoModalSTD('STDBY');
        setMostrarModalSTD(true);
        break;
      case 'PAUSE':
        setServicioSTD(service);
        setModoModalSTD('PAUSE');
        setMostrarModalSTD(true);
        break;
      case 'MIGRACION':
      case 'EQUIPAJE':
      case 'ADUANA':
      case 'ABORDAJE':
      case 'FINALIZADO':
      case 'NOSHOW':
        actualizarStatus(service._id, etapa);
        break;
      case 'CONCLUIDO':
        setMostrarModalEncuesta({ abierto: true, servicio: service });
        break;
      default:
        toast.info('Etapa no reconocida.');
    }
  };
  const abrirModalConexion = (servicio) => {
    setDatosConexion({ servicio, aerolinea: '', vuelo: '' });
    setMostrarModalConexion(true);
  };


  const cerrarModalConexion = () => {
    setMostrarModalConexion(false);
    setDatosConexion({ servicio: null, aerolinea: '', vuelo: '' });
  };

  const cerrarModalSTD = () => {
    setMostrarModalSTD(false);
    setCheckpointTexto('');
    setServicioSTD(null);
    setModoModalSTD('');
  };



  const guardarConexion = async () => {
    const aerolinea = datosConexion.aerolinea.toUpperCase().trim();
    const vuelo = datosConexion.vuelo.trim();

    if (!aerolinea || !vuelo) {
      toast.error('Por favor completa ambos campos: aerolínea y número de vuelo.');
      return;
    }

    const conexionFinal = `${aerolinea}${vuelo}`;

    try {
      await axios.put(`${API_BASE_URL}api/servicios/${datosConexion.servicio._id}`, {
        conexionCon: conexionFinal,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      toast.success(`Conexión registrada: ${conexionFinal}`);
      cerrarModalConexion();

      const response = await axios.get(`${API_BASE_URL}api/servicios/colaborador/${noColaborador}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setServicios(response.data);
    } catch (err) {
      console.error('Error al guardar conexión:', err);
      toast.error('Error al guardar conexión');
    }
  };


  const validarQRContraServicio = async () => {
    if (!modalQR?.servicio) {
      toast.error('No hay servicio seleccionado para validar.');
      return;
    }

    const qrText = codigoQR.trim();
    // 🔍 1. Datos del QR
    const pnr = qrText.substring(23, 29).trim(); // "GAVLKO"
    const origen_vuelo = qrText.substring(30, 33).trim().toUpperCase(); // "VSA"
    const destino_vuelo = qrText.substring(33, 36).trim().toUpperCase();
    const numero_vuelo = qrText.substring(39, 43).trim();
    const tipo_pasajero = qrText.substring(49, 52).trim().toUpperCase(); // "6C"
    const aerolinea = qrText.substring(36, 38).trim().toUpperCase();

    const match = qrText.match(/M1(.{1,20})/);
    const nombrePax = match ? match[1].trim() : 'PAX UH';

    try {


      if (qrText.length < 60) {
        toast.error('El código QR escaneado es inválido o muy corto.');
        return;
      }



      console.log('Datos extraídos del QR:', {
        pnr,
        origen_vuelo,
        numero_vuelo,
        tipo_pasajero,
        destino_vuelo,
        nombrePax
      });

      // 🔎 2. Validación según aerolínea
      const aerolineaServicio = modalQR?.servicio?.aerolinea?.toUpperCase?.() || aerolinea;
      if (aerolineaServicio === 'DL') {
        try {
          const urlDL = `${API_BASE_URL}api/pasajeros-vuelo/validar-asiento?noVuelo=${numero_vuelo}&fechaInput=${moment().format('YYYY-MM-DD')}&noAsiento=${tipo_pasajero}`;
          await axios.get(urlDL, { headers: { Authorization: `Bearer ${token}` } });

          // Existe en DL → confirmación y actualización sin usar validar-qr
          const confirmacion = window.confirm(
            `¿Validar al pasajero?\n\n👤 ${nombrePax}\n🎫 Asiento: ${tipo_pasajero}\nPNR: ${pnr}`
          );
          if (!confirmacion) {
            toast.info('Validación cancelada por el usuario.');
            return;
          }

          await axios.put(`${API_BASE_URL}api/servicios/${modalQR.servicio._id}`, {
            statusServicio: 'INICIADO',
            qr: pnr,
            nombrePax: nombrePax,
            noAsiento: tipo_pasajero,
            conexion: 'NO'
          }, {
            headers: { Authorization: `Bearer ${token}` }
          });

          toast.success('✅ Servicio actualizado y pasajero marcado como escaneado');
          setQrValidado(true);
          setErroresQR([]);
          return;
        } catch (e) {
          if (e.response?.status === 404) {
            // No existe asiento para DL -> registrar como UH y terminar
            await axios.put(`${API_BASE_URL}api/servicios/${modalQR.servicio._id}`, {
              statusServicio: 'INICIADO',
              qr: pnr,
              nombrePax: nombrePax,
              noAsiento: tipo_pasajero,
              uh: 'UH'
            }, {
              headers: { Authorization: `Bearer ${token}` }
            });

            toast.info('ℹ️ Asiento no encontrado en DL. Registrado como UH.');
            setQrValidado(true);
            setErroresQR([]);
            return;
          }
          // Otros errores: continuar con confirmación y actualizar sin validar-qr
          console.warn('Advertencia validando asiento DL:', e?.response?.status || e?.message);

          const confirmacion = window.confirm(
            `¿Validar al pasajero?\n\n👤 ${nombrePax}\n🎫 Asiento: ${tipo_pasajero}\nPNR: ${pnr}`
          );
          if (!confirmacion) {
            toast.info('Validación cancelada por el usuario.');
            return;
          }

          await axios.put(`${API_BASE_URL}api/servicios/${modalQR.servicio._id}`, {
            statusServicio: 'INICIADO',
            qr: pnr,
            nombrePax: nombrePax,
            noAsiento: tipo_pasajero,
            conexion: 'NO'
          }, {
            headers: { Authorization: `Bearer ${token}` }
          });

          toast.success('✅ Servicio actualizado y pasajero marcado como escaneado');
          setQrValidado(true);
          setErroresQR([]);
          return;
        }
      } else {
        // 🔗 3. Validar contra la tabla principal de pasajeros_vuelo (no DL)
        const url = `${API_BASE_URL}api/servicios/validar-qr?noVuelo=${numero_vuelo}&qr=${pnr}&noAsiento=${tipo_pasajero}`;
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const pasajero = res.data;

        // ✅ Confirmar antes de registrar
        const confirmacion = window.confirm(
          `¿Validar al pasajero?\n\n👤 ${pasajero.nombrePax}\n🎫 Asiento: ${pasajero.noAsiento}\nPNR: ${pasajero.pnr}`
        );

        if (!confirmacion) {
          toast.info('Validación cancelada por el usuario.');
          return;
        }

        // ✅ 4. Actualizar servicio con datos válidos
        await axios.put(`${API_BASE_URL}api/servicios/${modalQR.servicio._id}`, {
          statusServicio: 'INICIADO',
          qr: pasajero.pnr,
          nombrePax: `${pasajero.nombrePax}`,
          noAsiento: pasajero.noAsiento,
          conexion: pasajero.conexion || 'NO'
        }, {
          headers: { Authorization: `Bearer ${token}` }
        });

        toast.success('✅ Servicio actualizado y pasajero marcado como escaneado');
        setQrValidado(true);
        setErroresQR([]);
        return;
      }


    } catch (error) {
      if (error.response?.status === 409) {
        if (modalQR?.servicio?.tipoService === 'LLEGADAS') {
          toast.warn('⚠️ Pasajero ya escaneado previamente');
          setErroresQR(['Ya escaneado']);
          return;
        } else {
          // Si es SALIDA, ignoramos el conflicto y seguimos como si fuera válido
          const pasajero = error.response?.data || {};

          await axios.put(`${API_BASE_URL}api/servicios/${modalQR.servicio._id}`, {
            statusServicio: 'INICIADO',
            qr: pnr,
            nombrePax: nombrePax,
            noAsiento: tipo_pasajero,
            uh: 'UH'
          }, {
            headers: { Authorization: `Bearer ${token}` }
          });

          setQrValidado(true);
          setErroresQR([]);
          return;
        }
      }
      else if (error.response?.status === 404) {
        // 🧠 Si no existe, lo agregamos como UH
        try {
          await axios.put(`${API_BASE_URL}api/servicios/${modalQR.servicio._id}`, {
            statusServicio: 'INICIADO',
            qr: pnr,
            nombrePax: nombrePax,
            noAsiento: tipo_pasajero,
            uh: 'UH'
          }, {
            headers: { Authorization: `Bearer ${token}` }
          });

          toast.info('ℹ️ Pasajero UH agregado automáticamente al servicio');
          setQrValidado(true);
          setErroresQR([]);
        } catch (e) {
          console.error('❌ Error al agregar pasajero UH:', e);
          toast.error('Error al guardar pasajero UH');
          setQrValidado(false);
          setErroresQR(['Error al guardar pasajero UH']);
        }
      } else {
        console.error('Error validando QR:', error);
        toast.error('Error al validar QR');
        setQrValidado(false);
        setErroresQR([]);
      }
    }
  };


  //M1GUTIERREZ/BEATRIZ SUEGAVLKO VSAMEXAM 0809 353Y006C0161 162>5322OO4353BAM                                        2A1392149653680 0                          N



  return (

    <div className="mis-servicios-container">
      <ToastContainer />

      <h1>Mis Servicios Asignados</h1>

      <div className="mis-servicios-grid">
        {servicios.map((service) => {
          const etapas = obtenerEstadosPorServicio(service.tipoService, service.int_nac);
          const currentIndex = etapas.indexOf(service.statusServicio?.toUpperCase());

          return (
            <div className="mis-servicio-card" key={service._id}>
              <div className={`mis-servicio-header ${service.tipoSilla === 'UH' ? 'header-uh' : ''}`}>
                <span className="mis-tipo-servicio">
                  [{service.tipoService === 'LLEGADAS' ? 'L' : 'S'}] {service.aerolinea} {service.noVuelo}
                </span>
                <span className="mis-ruta-vuelo">
                  {service.origenVuelo?.toUpperCase()} <span className="flecha">→</span> {service.destinoVuelo?.toUpperCase()}
                </span>
                 <span className="mis-no-servicio">#{service._id}</span>
              </div>

              {/* Barra de progreso */}
              <div className="mis-status-progress-bar">
                {etapas.map((etapa, idx) => {
                  const isActive = idx <= currentIndex;
                  return (
                    <React.Fragment key={etapa}>
                      <div
                        className={`mis-circle-step ${isActive ? 'active' : ''}`}
                        title={etapa}
                        onClick={() => ejecutarAccionPorEtapa(etapa, service)}
                      >
                        {getIcon(etapa)}
                      </div>

                      {idx < etapas.length - 1 && (
                        <div className={`mis-step-line ${isActive ? 'active' : ''}`} />
                      )}
                    </React.Fragment>
                  );
                })}
              </div>

              <div className="mis-info-pax-vuelo">
                <div className="mis-info-pax">PAX: {service.nombrePax}</div>
                <div className="mis-info-vuelo">{service.aerolinea} {service.noVuelo}</div>
              </div>

              {service.conexion?.toUpperCase() === 'SI' && (
                <button className="btn-registrar-conexion" onClick={() => abrirModalConexion(service)}>
                  Registrar Conexión
                </button>

              )}


              <p><strong>Hora Inicio:</strong> {moment(service.horaInicio).format('HH:mm')}</p>
              <p><strong>Hora Fin:</strong> {service.horaFin ? moment(service.horaFin).format('HH:mm') : 'Sin finalizar'}</p>
              {service.statusServicio === 'ASIGNADO' && service.noMostrador && (
                <div className="direccion-mostrador">
                  🧭 <strong>Dirígete a:</strong> Mostrador <span className="mostrador-numero">{service.noMostrador}</span>
                </div>
              )}


            </div>
          );
        })}
      </div>
      {mostrarModalEncuesta && (
        <div className="modal-encuesta-overlay">
          <div className="modal-encuesta">
            <h3 style={{ textAlign: 'center', lineHeight: 1.4 }}>
              Califica el servicio de nuestro Agente<br />
              <strong>{decoded?.nombreCompleto || 'Agente'}</strong>
            </h3>

            <div className="caritas-feedback">
              <button onClick={() => setFeedback('EXCELENTE')} className={feedback === 'EXCELENTE' ? 'selected' : ''}>
                😊<br /><strong>BUENO</strong>
              </button>
              <button onClick={() => setFeedback('INTERMEDIO')} className={feedback === 'INTERMEDIO' ? 'selected' : ''}>
                😐<br /><strong>MEDIO</strong>
              </button>
              <button onClick={() => setFeedback('MALO')} className={feedback === 'MALO' ? 'selected' : ''}>
                😡<br /><strong>MALO</strong>
              </button>
            </div>


            <textarea
              placeholder="Comentarios (opcional)"
              value={comentarios}
              onChange={(e) => setComentarios(e.target.value)}
              rows={3}
              className="comentarios-textarea"
            />

            {/* Firma de pasajero y agente en la misma fila */}
            <div className="firmas-row">
              {/* Firma del pasajero */}
              <div className="firma-box">
                <div className="firma-label">Firma del pasajero:</div>
                <div className="firma-wrapper">
                  <SignatureCanvas
                    ref={firmaPasajeroRef}
                    penColor="black"
                    canvasProps={{ width: 300, height: 150, className: 'firma-canvas' }}
                  />
                  <div className="firma-marca-agua">PASAJERO</div>
                </div>
                <button className="btn-borrar-firma" onClick={() => firmaPasajeroRef.current.clear()}>
                  Borrar firma
                </button>
              </div>

              {/* Firma del agente 
              <div className="firma-box">
                <div className="firma-label">Firma del agente:</div>
                <div className="firma-wrapper">
                  <SignatureCanvas
                    ref={firmaAgenteRef}
                    penColor="black"
                    canvasProps={{ width: 300, height: 150, className: 'firma-canvas' }}
                  />
                  <div className="firma-marca-agua">AGENTE AEROLÍNEA</div>
                </div>
                <button className="btn-borrar-firma" onClick={() => firmaAgenteRef.current.clear()}>
                  Borrar firma
                </button>
              </div> */}
            </div>

            <div className="modal-buttons">
              <button className="btn-cancelar" onClick={() => setMostrarModalEncuesta(false)}>Cancelar</button>
              <button
                className="btn-concluir"
                onClick={async () => {
                  const firmaPasajeroVacia = firmaPasajeroRef.current?.isEmpty?.();

                  if (!feedback) {
                    toast.error('Por favor selecciona una calificación.');
                    return;
                  }

                  if (firmaPasajeroVacia) {
                    toast.error('La firma del pasajero es obligatoria.');
                    return;
                  }

                  // Firma y hora
                  const horaFin = moment().format('YYYY-MM-DD HH:mm:ss');

                  const firmaPasajero = firmaPasajeroRef.current
                    ? firmaPasajeroRef.current.toDataURL()
                    : null;

                  const encuesta = {
                    agente: decoded?.id || 'Agente',
                    calificacion: feedback,
                    comentarios,
                    firmaPasajero,
                  };
                  // Llamada a la función modificada
                  await actualizarStatus(
                    mostrarModalEncuesta.servicio._id,
                    'CONCLUIDO',

                  );

                  try {
                    await axios.put(`${API_BASE_URL}api/servicios/${mostrarModalEncuesta.servicio._id}`, {
                      encuesta
                    }, {
                      headers: { Authorization: `Bearer ${token}` },
                    });

                  } catch (error) {
                    console.error('Error al actualizar encuesta:', error);
                    toast.error('No se pudo actualizar encuesta.');
                  }


                  setMostrarModalEncuesta(false);
                }}
              >
                Concluir
              </button>

            </div>
          </div>
        </div>
      )}

      {modalQR.abierto && (
        <div className="modal-overlay">
          <div className="modal" style={{ maxWidth: 500 }}>
            <h3>Escanear pase de abordar</h3>
            <label>Código QR:</label>
            <div style={{ display: 'flex', gap: 10 }}>
              <input
                type="text"
                value={codigoQR}
                onChange={(e) => setCodigoQR(e.target.value)}
                placeholder="Escanea o ingresa el código"
                className="search-input"
              />
              <button
                className="btn-transfer"
                onClick={validarQRContraServicio}
              >
                Validar
              </button>



              {qrValidado && (
                <div style={{ marginTop: 10, color: 'green' }}>
                  <strong>✅ QR válido. Puedes iniciar el servicio.</strong>
                </div>
              )}


            </div>

            <div className="checkbox-group">
              <label>
                <input type="checkbox" id="sillaPropiaCheckbox" />
                Silla Propia
              </label>
              <label>
                <input type="checkbox" id="pasilleraCheckbox" />
                Pasillera
              </label>
            </div>



            <button
              className="btn-concluir"
              style={{ marginTop: 20 }}
              disabled={!qrValidado}
              onClick={async () => {
                try {
                  const tipoSillaArray = [];
                  if (document.getElementById('sillaPropiaCheckbox')?.checked) {
                    tipoSillaArray.push('SILLA PROPIA');
                  }
                  if (document.getElementById('pasilleraCheckbox')?.checked) {
                    tipoSillaArray.push('PASILLERA');
                  }

                  const tipoSillaFinal = tipoSillaArray.join(' - ');

                  const payload = {
                    statusServicio: 'INICIADO',
                  };

                  if (tipoSillaFinal) {
                    payload.tipoSilla = tipoSillaFinal;
                  }

                  await axios.put(`${API_BASE_URL}api/servicios/${modalQR.servicio._id}`, payload, {
                    headers: { Authorization: `Bearer ${token}` },
                  });

                  toast.success('Servicio iniciado');
                  setModalQR({ abierto: false, servicio: null });
                  setQrValidado(false);
                  setCodigoQR('');
                } catch (error) {
                  toast.error('Error al iniciar servicio');
                }
              }}
            >
              Iniciar Servicio
            </button>


            <button
              className="btn-cancel"
              onClick={() => {
                setModalQR({ abierto: false, servicio: null });
                setQrValidado(false);
                setCodigoQR('');
              }}
            >
              Cancelar
            </button>
          </div>
        </div>
      )}

      {mostrarModalConexion && (
        <div className="modal-overlay">
          <div className="modal" style={{ maxWidth: 400 }}>
            <h3>Registrar Conexión</h3>
            <input
              type="text"
              value={datosConexion.aerolinea}
              onChange={(e) => setDatosConexion({ ...datosConexion, aerolinea: e.target.value })}
              placeholder="Aerolínea (ej. AM)"
            />
            <input
              type="text"
              value={datosConexion.vuelo}
              onChange={(e) => setDatosConexion({ ...datosConexion, vuelo: e.target.value })}
              placeholder="Número de vuelo (ej. 128)"
            />
            <button className="btn-concluir" onClick={guardarConexion}>
              Guardar Conexión
            </button>
            <button className="btn-cancel" onClick={cerrarModalConexion}>
              Cancelar
            </button>

          </div>
        </div>
      )}

      {mostrarModalSTD && (
        <div className="modal-stdby-overlay">
          <div className="modal-stdby-container">
            <h3 className="modal-stdby-title">Registrar ubicación del pasajero</h3>
            <textarea
              className="modal-stdby-textarea"
              value={checkpointTexto}
              onChange={(e) => setCheckpointTexto(e.target.value)}
              placeholder="Ej. En sala de espera, junto a la puerta 3"
              rows={3}
            />
            <div className="modal-stdby-buttons">
              <button
                className="modal-stdby-btn guardar"
                onClick={async () => {
                  if (!checkpointTexto.trim()) {
                    toast.error('Debes ingresar una ubicación válida.');
                    return;
                  }

                  try {
                    const payload = {
                      statusServicio: modoModalSTD,
                      checkpoint: checkpointTexto.trim(),
                    };

                    if (modoModalSTD === 'STDBY') {
                      payload.noColaborador = 0; // solo desasignar si es STDBY
                    }


                    await axios.put(`${API_BASE_URL}api/servicios/${servicioSTD._id}`, payload, {
                      headers: { Authorization: `Bearer ${token}` }
                    });



                    toast.success('Ubicación registrada y servicio actualizado');
                    setMostrarModalSTD(false);
                    setCheckpointTexto('');
                    setServicioSTD(null);

                    const response = await axios.get(`${API_BASE_URL}api/servicios/colaborador/${noColaborador}`, {
                      headers: { Authorization: `Bearer ${token}` }
                    });
                    setServicios(response.data);
                  } catch (err) {
                    console.error('Error actualizando a STDBY:', err);
                    toast.error('Error al actualizar el servicio.');
                  }
                }}
              >
                Guardar
              </button>
              <button
                className="modal-stdby-btn cancelar"
                onClick={cerrarModalSTD}
              >
                Cancelar
              </button>

            </div>
          </div>
        </div>
      )}


    </div>
  );
};

export default MisServiciosPage;
